
        import _47vercel_47path0_47node_modules_47_64nuxt_47ui_47dist_47runtime_47vue_47plugins_47head_46js from "/vercel/path0/node_modules/@nuxt/ui/dist/runtime/vue/plugins/head.js"
import _47vercel_47path0_47node_modules_47_64nuxt_47ui_47dist_47runtime_47plugins_47colors_46js from "/vercel/path0/node_modules/@nuxt/ui/dist/runtime/plugins/colors.js"
export default {
  install (app) {
    app.use(_47vercel_47path0_47node_modules_47_64nuxt_47ui_47dist_47runtime_47vue_47plugins_47head_46js)
    app.use(_47vercel_47path0_47node_modules_47_64nuxt_47ui_47dist_47runtime_47plugins_47colors_46js)
  }
}
        